import Keycloak from 'keycloak-js';

/**
 * The corporate identity client for this application (house recipe,
 * `docs/identity/README.md` §6.2). The npm package name is unavoidable, but
 * the exported variable name, this file's name and every consumer keep the
 * rest of the codebase free of identity-provider naming — technology
 * concealment applies to this module's public surface, not to the import
 * line itself.
 *
 * Configuration comes exclusively from `VITE_AUTH_*` build-time variables
 * (never `VITE_KEYCLOAK_*`) — see `.env.example` and
 * `deploy/package/build-artifact.sh`'s `ALLOWED_BUILD_VARS`. None of these
 * three values is a secret: the authority URL and the realm are public
 * discovery endpoints, and the client id is a public OIDC client (PKCE
 * `S256`, no client secret — see the identity policy's mandatory public/PKCE
 * shape for a browser-only client).
 *
 * This module is imported unconditionally (the access-provider seam imports
 * both concrete providers statically — see `src/access/index.ts`), so the
 * three values below may legitimately be `undefined` here (e.g. when
 * `VITE_ACCESS_PROVIDER=local`, or an unconfigured `federated` build). The
 * `Keycloak` constructor itself only checks that these keys are *present* on
 * the object, never that they hold a real value, so this never throws at
 * module-eval time — `createFederatedAccessProvider` (the only consumer) is
 * the place that checks for a genuinely usable configuration before this
 * client is ever asked to do anything.
 */
export const ssoProvider = new Keycloak({
  url: import.meta.env.VITE_AUTH_URL as string,
  realm: import.meta.env.VITE_AUTH_REALM as string,
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID as string,
});
